module.exports = __webpack_public_path__ + "static/img/shuzhiSlogin.fe11049d.png";